export class CsvData {

  status: string;
  vorgangsnummerVM: string;
  anredeVN: string;
  nameVN: string;
  vornameVN: string;
  geburtsdatumVN: string;
  postleitzahlVN: string;
  wohnortVN: string;
  strasseVN: string;
  hausnummerVN: string;
  eMailVN: string;
  telefonVN: string;
  zahlungsweise: string;
  zahlungsart: string;
  abweichenderBeitragszahler: string;
  bankverbindungIBAN: string;
  vorsteuerabzugsberechtigungVN: string;
  rechtsformVN: string;
  abweichenderHalter: string;
  anredeHalter: string;
  nameHalter: string;
  vornameHalter: string;
  geburtsdatumHalter: string;
  postleitzahlHalter: string;
  wohnortHalter: string;
  strasseHalter: string;
  hausnummerHalter: string;
  rechtsformHalter: string;
  anredeBeitragszahler: string;
  nameBeitragszahler: string;
  vornameBeitragszahler: string;
  geburtsdatumBeitragszahler: string;
  postleitzahlBeitragszahler: string;
  ortBeitragszahler: string;
  strasseBeitragszahler: string;
  hausnummerBeitragszahler: string;
  beginn: string;
  ende: string;
  gewuenschterVersicherungsschutz: string;
  sFKlasseHaftpflicht: string;
  selbstbeteiligungTeilkasko: string;
  sFKlasseVollkasko: string;
  selbstbeteiligungVollkasko: string;
  schutzbrief: string;
  auslandsschadenschutz: string;
  fahrerPlusFahrerSchutz: string;
  rabattschutz: string;
  autoNotruf: string;
  bonusDrive: string;
  beitragsschutz: string;
  werkstattBonus: string;
  werterhaltGarantie: string;
  eigentumsverhaeltnisZumFahrzeug: string;
  erstzulassungDesFahrzeuges: string;
  ersteZulassungAufDenVNHalter: string;
  fahrzeugidentifizierungsnummer: string;
  herstellerschluessel: string;
  typschluessel: string;
  wagniskennziffer: string;
  amtlichesKennzeichen: string;
  saisonkennzeichen: string;
  betriebszeitraumVonMonat: string;
  betriebszeitraumBisMonat: string;
  betriebsausgabe: string;
  beitragVorVUGesamt: string;
  beitragVorVUKH: string;
  beitragVorVUKasko: string;
  beitragVorVUSonstiges: string;
  beitragVorVUInsassenUnfall: string;
  vorVUNrGDVNr: string;
  amtlichesKennzeichenDerVorversicherung: string;
  saisonkennzeichenDerVorversicherung: string;
  versicherungsscheinnummerDerVorversicherung: string;
  hinweis: string;
  deckungKH: string;
  produktlinie: string;
  bemerkung: string;
  aZBeitragGesamt: string;
  aZBeitragKH: string;
  aZBeitragKasko: string;
  nachlassZuschlagGesamt: string;
  nachlassZuschlagKH: string;
  nachlassZuschlagKasko: string;

}
